import { AreaStockCountView } from "@medicorepay/ui";
import { useNavigate } from "react-router-dom";
import { productRevivalApi } from "../../services/product-revival-client";
import { useAuthStore } from "../../stores/authStore";

export default function PhysicalStockCountsPage() {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const storeId =
    useAuthStore((state) => state.selectedStoreId) ||
    user?.storeId ||
    "active-store";

  return (
    <AreaStockCountView
      getAreas={() => productRevivalApi.getInventoryCountAreas()}
      getReview={(area) => productRevivalApi.getInventoryCountReview(area)}
      getHistory={(query) => productRevivalApi.getInventoryCountHistory(query)}
      postCount={(body, idempotencyKey) =>
        productRevivalApi.postStockCount(body, {
          idempotencyKey,
          clientApplication: "web",
        })
      }
      onBack={() => navigate("/stock")}
      idempotencyScope={storeId}
    />
  );
}
